import React, { FC } from "react";

import { FullscreenFallback } from "../DialogComponents/DialogFallback/FullscreenFallback";

export const InfoResource: FC = () => (
  <FullscreenFallback
    context={{
      title: {
        icon: "info",
      },
    }}
  />
);
